export default function OutlinedInput() {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
        },
      },
    },
  }
}
